import React from 'react';
import { ReactComponent as Logo } from '../assets/Icons/logo.svg';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="px-6 py-10 sm:px-10 sm:py-12 bg-background-secondary text-white">
      <div className="max-w-screen-2xl mx-auto">
        <div className="max-w-7xl mx-auto flex justify-between flex-wrap gap-8">
          <div className="space-y-6">
            <Logo className="h-14 text-sm" />
            <div>
              <p>2433 Coolidge Ave</p>
              <p>Oakland, CA 94601</p>
            </div>
            <div>(626) 966–4576</div>
          </div>
          <div className="space-y-6 text-sm font-semibold">
            <p>
              <Link to={'https://tech.elmwoodinstitute.org/#'}>
                About Elmwood Institute
              </Link>
            </p>
            <p>
              <Link to={'https://www.elmwoodinstitute.org/mission-goals'}>
                Mission & History
              </Link>
            </p>
            <p>
              <Link
                to={'https://www.elmwoodinstitute.org/accreditation-licensure'}
              >
                Licensing
              </Link>
            </p>
          </div>
          <div className="space-y-6 text-sm font-semibold">
            <p>
              <Link to={'https://www.elmwoodinstitute.org/policies'}>
                Copyright, Trademark & Privacy Policy
              </Link>
            </p>
            <p>
              <Link to={'https://www.elmwoodinstitute.org/terms-of-use'}>
                Terms of Use
              </Link>
            </p>
            <p>
              <Link to={'https://www.elmwoodinstitute.org/contactus'}>
                Contact Us
              </Link>
            </p>
          </div>
        </div>
        <div className="border-t border-white/50 mt-10 pt-4 flex flex-col md:flex-row justify-between items-start md:items-center text-white/80 text-xs">
          <p>
            Accredited by the{' '}
            <span className="font-semibold text-white">
              Distance Education Accrediting Commission (DEAC)
            </span>
          </p>
          <p>Copyright © {new Date().getFullYear()} by Elmwood Institute</p>
        </div>
      </div>
    </footer>
  );
};
